import { getOrderSeatsForShowtime } from '@vista/omnichannel-components-domain';
import { observer } from 'mobx-react';
// This provider component is necessary to prevent recreating the seatingData when the selectedSeats change.
// If new seatingData is recreated then it will cause performance issues due to all of the SeatPicker re-rendering.
export const SelectedSeatIdsProvider = observer(props => {
    var _a;
    const { showtimeId, render } = props;
    const selectedSeats = getOrderSeatsForShowtime(showtimeId);
    const selectedSeatIds = selectedSeats.map(seat => seat.seatId);
    return (_a = render(selectedSeatIds)) !== null && _a !== void 0 ? _a : null;
});
SelectedSeatIdsProvider.displayName = 'SelectedSeatIdsProvider';
